import React from 'react'

function Footer() {
  return (
    <>
    <style>{`
      .floating_contact_btn {
        position: fixed !important;
        bottom: 20px !important;
        top: auto !important;
        width: 56px;
        height: 56px;
        border-radius: 50% !important;
        display: flex !important;
        align-items: center;
        justify-content: center;
        z-index: 9999 !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);
        text-decoration: none !important;
        font-size: 24px;
        line-height: 1;
        transition: transform 0.25s ease, box-shadow 0.25s ease;
      }
      .floating_contact_btn:hover,
      .floating_contact_btn:focus-visible {
        transform: translateY(-3px) scale(1.06);
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.3);
        text-decoration: none !important;
      }
      .floating_contact_btn:active {
        transform: translateY(0) scale(0.96);
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
      }
      .floating_contact_btn i {
        pointer-events: none;
      }
      .floating_whatsapp_btn {
        right: 20px !important;
        left: auto !important;
        background-color: #25D366 !important;
        color: #ffffff !important;
      }
      .floating_whatsapp_btn:hover,
      .floating_whatsapp_btn:focus-visible {
        color: #ffffff !important;
        background-color: #22bf5b !important;
      }
      .floating_whatsapp_btn i {
        color: #ffffff !important;
      }
      .floating_call_btn {
        left: 20px !important;
        right: auto !important;
        background-color: #f59e0b !important;
        color: #ffffff !important;
        border: none;
      }
      .floating_call_btn:hover,
      .floating_call_btn:focus-visible {
        color: #ffffff !important;
        background-color: #d97706 !important;
      }
      .floating_call_btn i {
        color: #ffffff !important;
      }
      @media (max-width: 576px) {
        .floating_contact_btn {
          width: 50px;
          height: 50px;
          font-size: 21px;
          bottom: 16px !important;
        }
        .floating_whatsapp_btn {
          right: 14px !important;
        }
        .floating_call_btn {
          left: 14px !important;
        }
      }
    `}</style>

    <a
      href="https://wa.me/917311104573"
      className="floating_contact_btn floating_whatsapp_btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <i className="fa-brands fa-whatsapp"></i>
    </a>

    <a
      href="tel:6394856756"
      className="floating_contact_btn floating_call_btn"
      aria-label="Call us"
      title="Call us"
    >
      <i className="fa-solid fa-phone"></i>
    </a>

    <footer className="site_footer footer_layout_1 bg-secondary section_decoration" style={{backgroundImage: "url('assets/images/backgrounds/footer_bg_1.webp')"}}>
    <div className="container">
      <div className="footer_newsletter pb-0">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-6">
            <div className="heading_block mb-0 text-white">
              <h2 className="heading_text mb-0">
                Subscribe for daily update
              </h2>
            </div>
          </div>
          <div className="col-lg-4">
            <form className="newsletter_input" action="#">
              <label htmlFor="footer_newsletter_input">
                <img src="assets/images/icons/icon_email.svg" alt="Icon Email"/>
              </label>
              <input id="footer_newsletter_input" type="email" name="email" placeholder="Email address"/>
              <button className="submit_btn" type="submit">
                <i className="fa-solid fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="footer_content_wrapper">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="site_logo">
              <a className="site_link" href="/">
                <img src="assets/images/1.png" alt="Site Logo"/>
              </a>
            </div>
            <ul className="iconlist_block unordered_list_block">
              <li>
                <a href="tel:+917311104571">
                  <span className="iconlist_icon">
                    <img src="assets/images/icons/icon_calling_2.svg" alt="Icon Calling"/>
                  </span>
                  <span className="iconlist_text">+91 7311104571</span>
                </a>
              </li>
              <li>
                <a href="mailto:sales@mokshiq.in">
                  <span className="iconlist_icon">
                    <img src="assets/images/icons/icon_email_2.svg" alt="Icon Email"/>
                  </span>
                  <span className="iconlist_text">sales@mokshiq.in</span>
                </a>
              </li>
              <li>
                <a href="mailto:support@mokshiq.in">
                  <span className="iconlist_icon">
                    <img src="assets/images/icons/icon_email_2.svg" alt="Icon Email"/>
                  </span>
                  <span className="iconlist_text">support@mokshiq.in</span>
                </a>
              </li>
            </ul>
            <p className="mb-0 pe-lg-5 text-white-50">
              <strong>Corporate Office:</strong> 1st Floor, C 78, Sector-2 Noida
            </p>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 pe-lg-5">
            <h3 className="footer_info_title">Quick Links</h3>
            <ul className="iconlist_block unordered_list_block">
              <li>
                <a href="/about_us">
                  <span className="iconlist_text">About Us</span>
                </a>
              </li>
              <li>
                <a href="/services">
                  <span className="iconlist_text">Services</span>
                </a>
              </li>
              <li>
                <a href="/sprintverify">
                  <span className="iconlist_text">Verify APIs</span>
                </a>
              </li>
              <li>
                <a href="/recharge_api">
                  <span className="iconlist_text">Recharge API</span>
                </a>
              </li>
              <li>
                <a href="/aeps_dmt_services">
                  <span className="iconlist_text">AEPS & Banking</span>
                </a>
              </li>
              <li>
                <a href="https://retailer.mokshiq.in">
                  <span className="iconlist_text">Retailer Panel</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 pe-lg-5">
            <h3 className="footer_info_title">Information</h3>
            <ul className="iconlist_block unordered_list_block">
              <li>
                <a href="/career">
                  <span className="iconlist_text">Career</span>
                </a>
              </li>
              <li>
                <a href="/privacy_policy">
                  <span className="iconlist_text">Privacy Policy</span>
                </a>
              </li>
              <li>
                <a href="/terms_of_conditions">
                  <span className="iconlist_text">Terms & Conditions</span>
                </a>
              </li>
              <li>
                <a href="/refund_and_cancellation">
                  <span className="iconlist_text">Refund & Cancellation</span>
                </a>
              </li>
              <li>
                <a href="/contact_us">
                  <span className="iconlist_text">Contact Us</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 pe-lg-5">
            <h3 className="footer_info_title">Download App</h3>
            <p className="pe-lg-5">
              Available on Android Play Store & Web Portal
            </p>
            <ul className="app_download_btns unordered_list_block">
              <li>
                <a href="#">
                  <img src="assets/images/app_store.webp" alt="App Store"/>
                </a>
              </li>
              <li>
                <a href="#">
                  <img src="assets/images/google_play.webp" alt="Google Play"/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer_bottom">
        <div className="row">
          <div className="col-md-7">
            <p className="copyright_text mb-0 text-white">
              Copyright © 2025 <strong>Mokshiq</strong>, a product of <strong>Rakle Service Private Limited</strong>. All rights reserved.
            </p>
          </div>
          <div className="col-md-6">
            <div className="d-flex align-items-center justify-content-center justify-content-md-end">
              <p className="mb-0 text-white">Follow Us -</p>
              <ul className="social_icons_block unordered_list ms-3">
                <li>
                  <a aria-label="Twitter X" href="#!">
                    <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.92704 6.35148L14.5111 0H13.1879L8.33921 5.5149L4.4666 0H0L5.85615 8.3395L0 15H1.32333L6.44364 9.17608L10.5334 15H15L8.92671 6.35148H8.92704ZM7.11456 8.41297L6.52121 7.58255L1.80014 0.974755H3.83269L7.64265 6.30746L8.236 7.13788L13.1885 14.0696H11.156L7.11456 8.41329V8.41297Z"/>
                    </svg>
                  </a>
                </li>
                <li><a aria-label="Facebook" href="#!"><i className="fa-brands fa-facebook-f"></i></a></li>
                <li><a aria-label="Linkedin" href="#!"><i className="fa-brands fa-linkedin-in"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="decoration_item shape_nate">
      <img src="assets/images/shapes/shape_nate_2.svg" alt="Shape Nate"/>
    </div>
    <div className="decoration_item shape_dollar_1">
      <img src="assets/images/shapes/shape_dollar_5.webp" data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Nate"/>
    </div>
    <div className="decoration_item shape_dollar_2">
      <img src="assets/images/shapes/shape_dollar_3.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Nate"/>
    </div>
  </footer>
  </>
  )
}

export default Footer